/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'linkDataSource.accessInstructions': '要申请访问权限，请联系您的站点管理员。',
  'linkDataSource.accessRequired': '您无权访问此内容',
  'linkDataSource.accessRequiredWithSite': '您无权访问以下站点：',
  'linkDataSource.assets.configModal.aqlSearchInput.helpTooltipText': '语法帮助',
  'linkDataSource.assets.configModal.aqlSearchInput.placeholder': '通过 AQL 搜索',
  'linkDataSource.assets.configModal.objectSchemaSelect.label': '选择架构',
  'linkDataSource.assets.configModal.objectSchemaSelect.placeholder': '选择架构',
  'linkDataSource.assets.configModal.objectSchemaSelect.schemaRequired': '必须选择架构',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.learnMoreLink': '详细了解如何使用 AQL 进行搜索。',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.searchDescription': '开始输入搜索内容或使用 AQL 进行搜索。',
  'linkDataSource.assets.configModal.renderAssetsContent.initialStateView.searchTitle': '搜索对象',
  'linkDataSource.assets.configmodal.insertIssuesButtonText': '{objectsCount, plural, other {插入对象}}',
  'linkDataSource.assets.configmodal.insertObjectsTitle': '插入以下来源的对象：',
  'linkDataSource.assets.configmodal.updateObjectsButtonText': '更新表格',
  'linkDataSource.basic-filter.assignee.label': '经办人',
  'linkDataSource.basic-filter.dropdown.select.assignee.unassigned': '未分配',
  'linkDataSource.basic-filter.dropdown.select.placeholder': '搜索',
  'linkDataSource.basic-filter.error-message': '出错了',
  'linkDataSource.basic-filter.footer.pagination-details': '{currentDisplayCount}/{totalCount}',
  'linkDataSource.basic-filter.loading-message': '正在加载...',
  'linkDataSource.basic-filter.no-options-message': '未找到匹配项',
  'linkDataSource.basic-filter.project.label': '项目',
  'linkDataSource.basic-filter.showMoreButton': '显示更多',
  'linkDataSource.basic-filter.status.label': '状态',
  'linkDataSource.basic-filter.type.label': '类型',
  'linkDataSource.checkConnection': '请检查连接并刷新，或稍后重试。',
  'linkDataSource.clol-basic-filter.editedOrCreatedBy.label': '编辑者或创建者',
  'linkDataSource.column-picker.no-all-items-shown-message.line-1': '搜索返回的结果过多。',
  'linkDataSource.column-picker.no-all-items-shown-message.line-2': '请使用更具体的关键词重试。',
  'linkDataSource.column-picker.search': '搜索字段',
  'linkDataSource.column-picker.tooltip': '配置列',
  'linkDataSource.configmodal.basicTextSearchPlaceholder': '按关键字搜索事务',
  'linkDataSource.configmodal.basicTextSearchPlaceholder-issue-term-refresh': '按关键字搜索工作项',
  'linkDataSource.configmodal.cancelButtonText': '取消',
  'linkDataSource.confluence-search.configmodal.cancelButtonText': '取消',
  'linkDataSource.confluence-search.configmodal.date.range.after.label': '在 {date}之后',
  'linkDataSource.confluence-search.configmodal.date.range.any.time': '任何时间',
  'linkDataSource.confluence-search.configmodal.date.range.before.label': '在 {date}之前',
  'linkDataSource.confluence-search.configmodal.date.range.custom': '自定义',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.after.end': '起始日期必须早于截止日期',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.after.today': '起始日期不能是未来日期',
  'linkDataSource.confluence-search.configmodal.date.range.custom.invalid.to.after.today': '结束日期不能是未来日期',
  'linkDataSource.confluence-search.configmodal.date.range.error': '日期范围错误',
  'linkDataSource.confluence-search.configmodal.date.range.from': '从',
  'linkDataSource.confluence-search.configmodal.date.range.input.placeholder': '选择日期',
  'linkDataSource.confluence-search.configmodal.date.range.last.month': '过去 30 天',
  'linkDataSource.confluence-search.configmodal.date.range.last.week': '过去 7 天',
  'linkDataSource.confluence-search.configmodal.date.range.last.year': '去年',
  'linkDataSource.confluence-search.configmodal.date.range.title': '上次更新时间',
  'linkDataSource.confluence-search.configmodal.date.range.to': '至',
  'linkDataSource.confluence-search.configmodal.date.range.to.Label': '至',
  'linkDataSource.confluence-search.configmodal.date.range.today': '今天',
  'linkDataSource.confluence-search.configmodal.date.range.update.button': '更新',
  'linkDataSource.confluence-search.configmodal.date.range.yesterday': '昨天',
  'linkDataSource.confluence-search.configmodal.insertConfluenceTitle': '插入 Confluence 列表',
  'linkDataSource.confluence-search.configmodal.insertConfluenceTitleManySites': 'Confluence 列表插入来源',
  'linkDataSource.confluence-search.configmodal.insertResultsButtonText': '插入结果',
  'linkDataSource.confluence-search.configmodal.placeholder.issues': '### 结果数',
  'linkDataSource.confluence-search.configmodal.searchLabel': '输入关键字以查找页面、附件等',
  'linkDataSource.confluence-search.no.confluence.sites.access.description': '要申请访问权限，请联系您的管理员。',
  'linkDataSource.confluence-search.no.confluence.sites.access.title': '您无权访问任何 Confluence 站点',
  'linkDataSource.datasource.table.authConnectButtonText': '连接',
  'linkDataSource.datasource.table.authScreenDescriptionText': '关联您的 {providerName} 帐户，以便跨 Atlassian 产品协作处理工作。',
  'linkDataSource.datasource.table.authScreenHeaderText': '连接您的 {providerName} 帐户',
  'linkDataSource.datasource.table.learnMoreAboutSmartLinks': '了解有关智能链接的更多信息。',
  'linkDataSource.issue-line-table.error-403-description': '您需要有相应的权限才能编辑此项目。',
  'linkDataSource.issue-line-table.error-403-title': '更改未保存',
  'linkDataSource.issue-line-table.error-generic-description': '我们在尝试完成更新时遇到问题。请稍等几分钟，然后重试。如果此情况持续发生，请联系支持团队。',
  'linkDataSource.issue-line-table.error-generic-title': '出错了',
  'linkDataSource.issue-line-table.fetch-action-error-generic-description': '请稍等几分钟，然后重试。如果此情况持续发生，请检查您的项目设置，或联系支持团队。',
  'linkDataSource.issue-line-table.fetch-action-error-generic-title': '获取选项时遇到问题',
  'linkDataSource.issue-line-table.unwrap-text': '取消换行',
  'linkDataSource.issue-line-table.wrap-text': '换行',
  'linkDataSource.checkConnectionWithSource': '请检查连接并刷新，或<a>在 Jira 中打开此查询</a>以进行查看。',
  'linkDataSource.jira-issues.configmodal.basicModeSwitchDisabledTooltipText': '对于此查询，您无法切换至基本模式。',
  'linkDataSource.jira-issues.configmodal.basicModeText': '基本',
  'linkDataSource.jira-issues.configmodal.basicTextSearchPlaceholder-issue-term-refresh': '按关键字搜索工作项',
  'linkDataSource.site-selector.configmodal.chooseSite': '选择站点',
  'linkDataSource.jira-issues.configmodal.insertIssuesButtonText': '插入事务',
  'linkDataSource.jira-issues.configmodal.insertIssuesButtonText-issue-term-refresh': '插入工作项',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitle': '插入 Jira 事务',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitle-issue-term-refresh': '插入 Jira 工作项',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitleManySites': '插入以下来源的 Jira 事务：',
  'linkDataSource.jira-issues.configmodal.insertIssuesTitleManySites-issue-term-refresh': '插入以下来源的 Jira 工作项：',
  'linkDataSource.jira-issues.configmodal.placeholder.issues-issue-term-refresh': '### 个工作项',
  'linkDataSource.jira-issues.configmodal.viewModeInlineLinkDescription': '以内联智能链接的形式显示搜索结果的数量',
  'linkDataSource.jira-issues.configmodal.viewModeInlineLinkLabel': '内联链接',
  'linkDataSource.jira-issues.configmodal.viewModeListDescription': '以列表形式显示搜索结果',
  'linkDataSource.jira-issues.configmodal.viewModeListLabel': '列表',
  'linkDataSource.jira-issues.learnMoreLink': '了解如何使用 JQL 进行搜索',
  'linkDataSource.no.jira.sites.access.description': '要申请访问权限，请联系您的管理员。',
  'linkDataSource.no.jira.sites.access.title': '您无权访问任何 Jira 站点',
  'linkDataSource.noResultsFound': '未找到结果',
  'linkDataSource.refresh': '刷新',
  'linkDataSource.jira-issues.searchDescription-basic': '按关键字搜索要插入的事务。',
  'linkDataSource.jira-issues.searchDescription-jql': '使用 JQL（Jira 查询语言）来搜索事务。',
  'linkDataSource.jira-issues.searchJiraTitle': '搜索 Jira 事务',
  'linkDataSource.unableToLoadItems': '无法加载项目',
  'linkDataSource.unableToLoadResults': '无法加载结果',
  'linkDataSource.modal-initial-state.beta': '测试版',
  'linkDataSource.modal-initial-state.confluenceSearchTitle': '搜索 Confluence 页面',
  'linkDataSource.modal-initial-state.jiraSearchTitle': '搜索 Jira 事务',
  'linkDataSource.modal-initial-state.searchDescription-basic-issue-term-refresh': '按关键字搜索要插入的工作项。',
  'linkDataSource.modal-initial-state.searchDescription-confluence': '按关键字搜索要插入的页面。',
  'linkDataSource.modal-initial-state.searchDescription-jql-issue-term-refresh': '使用 JQL（Jira 查询语言）来搜索工作项。',
  'linkDataSource.modal-initial-state.searchTitle-issue-term-refresh': '搜索 Jira 工作项',
  'linkDataSource.render-type.boolean.false': '否',
  'linkDataSource.render-type.boolean.true': '是',
  'linkDataSource.render-type.user.default.display.name': '未分配',
  'linkDataSource.search.configmodal.issueCountText': '{searchCount, plural, other {{searchCount,number} 个事务}}',
  'linkDataSource.search.configmodal.issueCountText-issue-term-refresh': '{searchCount, plural, other {{searchCount,number} 个工作项}}',
  'linkDataSource.search.configmodal.itemCountText': '{searchCount, plural, other {{searchCount,number} 个项目}}',
  'linkDataSource.search.configmodal.resultCountText': '{searchCount, plural, other {{searchCount,number} 个结果}}',
  'linkDataSource.table-footer.date_formatter.under_one_minute': '刚才已同步',
  'linkDataSource.table-footer.date_formatter.under_over_minute': '已于 {date}同步',
  'linkDataSource.table-footer.item': '{itemCount, plural, other {个项目}}',
  'linkDataSource.table-footer.loading': '正在加载...',
  'linkDataSource.table-footer.power-by-jsm': '由 Jira Service Management 中的资产提供支持',
  'linkDataSource.table-footer.powered-by-assets': '由资产提供支持',
  'linkDataSource.table-footer.refresh': '刷新'
};